import React, { useEffect } from 'react';
import { Lightbulb, Users, BarChart, Trophy } from 'lucide-react';

const MOCK_DATA = {
  hero: {
    title: "Powering Your Projects, Brightening Your Future.",
    subtitle: "Lumiotec ELECTRICALS is Kenya's leading supplier of quality, certified electrical components and tools for professionals and enthusiasts.",
    imageUrl: "https://placehold.co/1200x500/f3f4f6/1f2937?text=Modern+Electrical+Warehouse+Scene"
  },
  mission: {
    title: "Our Story: Quality You Can Trust",
    content: "Founded in 2018 in Nairobi, Lumiotec was built on the belief that securing high-quality, reliable electrical components shouldn't be a challenge. We started small, focusing on fast delivery and impeccable customer service. Today, we source products globally, ensuring every item meets strict international and local standards, helping drive innovation across the East African region. We are committed to fostering growth and safety in every installation.",
  },
  values: [
    { icon: Lightbulb, title: "Innovation", description: "Always seeking new, energy-efficient, and smart electrical solutions to meet tomorrow's needs." },
    { icon: Trophy, title: "Quality Assurance", description: "Every product is rigorously tested and certified, guaranteeing safety, durability, and performance." },
    { icon: Users, title: "Customer Focus", description: "Our commitment is to your project's success, providing expert support and personalized service." },
    { icon: BarChart, title: "Integrity & Trust", description: "Transparent pricing and ethical business practices form the bedrock of all our customer relationships." },
  ]
};

const AboutUs = () => {
  useEffect(() => {
    document.title = "Lumiotec | About Us";
  }, []);

  return (
    <div className="bg-white min-h-screen">
      <div className="bg-gray-50 py-24 sm:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
            <p className="text-base font-semibold leading-7 text-red-600">Our Commitment</p>
            <h1 className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">{MOCK_DATA.hero.title}</h1>
            <p className="mt-6 text-lg leading-8 text-gray-600">{MOCK_DATA.hero.subtitle}</p>
            <div className="mt-10">
                <a href="#mission" className="rounded-md bg-red-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600">
                    Read Our Story
                </a>
            </div>
        </div>
      </div>

      <div id="mission" className="py-24 sm:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center">
                <p className="text-base font-semibold leading-7 text-red-600">Who We Are</p>
                <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{MOCK_DATA.mission.title}</h2>
                <div className="mt-6 text-lg leading-8 text-gray-600 space-y-4">
                    <p>{MOCK_DATA.mission.content.substring(0, MOCK_DATA.mission.content.indexOf('Today'))}</p>
                    <p>{MOCK_DATA.mission.content.substring(MOCK_DATA.mission.content.indexOf('Today'))}</p>
                </div>
            </div>
        </div>
      </div>

      <div className="bg-red-50 py-24 sm:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Our Core Values</h2>
            <p className="mt-4 text-lg leading-8 text-gray-600">The principles that guide our every decision, from sourcing to customer service.</p>
          </div>
          <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {MOCK_DATA.values.map((value, index) => (
              <div key={index} className="bg-white p-8 rounded-lg shadow-lg border-t-4 border-red-600">
                <value.icon size={36} className="text-red-600 mb-4" />
                <h3 className="text-xl font-bold text-gray-900 mb-2">{value.title}</h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-gray-800 py-24 sm:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">Ready to Start Your Next Project?</h2>
            <div className="mt-10">
                <a href="/contact" className="rounded-md bg-orange-500 px-4 py-3 text-base font-semibold text-white shadow-sm hover:bg-orange-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500">
                    Contact Our Experts Today
                </a>
            </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
